/**
 * Converter number to positive
 * @param {?} val
 * @param {?=} state
 * @return {?}
 */
export function toPositiveNumber(val, state) {
    if (state === void 0) { state = false; }
    var /** @type {?} */ numState = val >= 0 ? 1 : -1;
    var /** @type {?} */ num;
    if (numState === -1) {
        num = val * -1;
    }
    else {
        num = val;
    }
    if (state) {
        return numState;
    }
    else {
        return num;
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/app/alyle-ui-profile/shadow/toPositiveNumber.js
// module id = 1364
// module chunks = 31